import React from 'react';
import { Expense } from '../../../../model/expense';
import { entityManagerProvider } from '../../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { ExpenseType } from '../../../../model/expense-type';
interface ExpenseList {
  expense: Expense[];
  expenseTypes: ExpenseType[];
  selected: Expense;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
}

class Expenses extends React.Component<any, ExpenseList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      expense: [] as Expense[],
      expenseTypes: [] as ExpenseType[],
      selected: null as Expense,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
    };
    this.manager = entityManagerProvider.newManager();
    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addExpense = this.addExpense.bind(this);
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('Expenses')
      .where('equipmentId', 'equals', this.props.currentProductId)
      .expand('expenseType, applicationUser');
    const queryExpenseType = new EntityQuery('ExpenseTypes');
    this.manager.executeQuery(queryExpenseType).then((qr) => {
      this.setState({
        expenseTypes: qr.results,
      });
    });
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        expense: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addExpense() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let expense = this.manager.createEntity(Expense.prototype.entityType, {
      expenseId: this.state.ids,
      applicationUserId: this.props.authorizedUser.Id,
      createdOn: new Date(),
      modifiedOn: new Date(),
      equipmentId: this.props.currentProductId,
    }) as Expense;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: expense,
      expense: this.state.expense.concat([expense]),
    });
  }

  remove(ent: Expense) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          selected: null,
          expense: this.manager.getEntities('Expense') as Expense[],
        });
      })
      .catch((error) => {
        this.setState({
          selected: null,
          expense: this.manager.getEntities('Expense') as Expense[],
        });
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        this.setState({
          loading: false,
          selected: null,
          allowAdd: true,
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    this.setState({
      selected: null,

      expense: this.manager.getEntities('Expense') as Expense[],
      allowAdd: true,
    });
  }

  renderPaymentEdit() {
    let expense = this.state.selected;
    function handleCatChange(event) {
      expense.expenseTypeId = event.target.value;
    }

    if (expense) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() ||
                  !this.state.selected?.expenseTypeId
                }
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, expense)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="expenseName"
                      value={expense.expenseName || ''}
                      onChange={expense.handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>Amount</label>
                    <input
                      className="form-control"
                      type="number"
                      name="expenseValue"
                      value={expense.expenseValue || ''}
                      onChange={expense.handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>exChange Rate</label>
                    <input
                      className="form-control"
                      type="number"
                      name="exchangeRate"
                      value={expense.exchangeRate || ''}
                      onChange={expense.handleChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <label>Expense Type</label>
                    <select
                      className="form-control"
                      name="expenseTypeId"
                      onChange={handleCatChange}
                      value={expense.expenseTypeId || 0}
                    >
                      <option key={0} value={0}>
                        Select ExpenseType
                      </option>
                      {this.state.expenseTypes?.map((cat) => {
                        return (
                          <option
                            key={cat.expenseTypeId}
                            value={cat.expenseTypeId}
                          >
                            {cat.expenseTypeName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: Expense) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Expenses
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Custom, Loading , Shipment ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addExpense}
              disabled={!this.state.allowAdd}
            >
              Add Expense
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '300px' }}>
                  <Table className="table" bordered>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Amount</th>
                        <th>Rate</th>
                        <th>Created</th>
                        <th>Modified</th>
                        <th>User</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.expense?.map((type, idx) => {
                        return (
                          <tr
                            key={type.expenseId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.expenseType?.expenseTypeName}</td>
                            <td>{type.expenseName}</td>
                            <td>{type.expenseValue}</td>
                            <td>{type.exchangeRate}</td>
                            <td>{this.dateFormatter(type.createdOn)}</td>
                            <td>{this.dateFormatter(type.modifiedOn)}</td>
                            <td>{type.applicationUser?.fullName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="col-xl-6">{this.renderPaymentEdit()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Expenses;
